/**
 * Shared constants for the native sync queue system.
 * These values mirror the SW queue behavior for consistency.
 */

/** Maximum retry attempts before marking as permanent failure */
export const MAX_RETRIES = 3

/** How long to keep entries before considering them stale (30 days in ms).
 *  Bumped 7d → 30d: a queued mutation is the user's unsynced work, so we keep
 *  it well beyond a week before auto-pruning, while still bounding growth.
 *  `cleanupStaleEntries` (in nativeQueueManager) stays active on this window. */
export const MAX_RETENTION_MS = 30 * 24 * 60 * 60 * 1000

/** Interval between automatic sync attempts (10 seconds) */
export const SYNC_RETRY_INTERVAL_MS = 10 * 1000

/** Debounce delay for sync triggers to prevent rapid-fire syncs (300ms) */
export const SYNC_DEBOUNCE_MS = 300

/** Maximum queue size to prevent unbounded growth */
export const MAX_QUEUE_SIZE = 1000

/** Preview length for comment text in queue display */
export const COMMENT_PREVIEW_LENGTH = 15

/** Base delay for exponential backoff (1 second) */
export const BACKOFF_BASE_MS = 1000

/** Maximum delay for exponential backoff (1 minute) */
export const BACKOFF_MAX_MS = 60 * 1000
